<template>
    <div class="cs-logo-reel cs-block" :class="styleClass">
        <div class="cs-block-base">
            <div class="container">
                <div class="header-content">
                    <h2 class="cs-title" v-if="data.title">
                        <ColorSplit :data="data.title" />
                    </h2>
                    <h3 class="cs-sub-title" v-if="data.subTitle">{{ data.subTitle }}</h3>
                    <span v-if="data.text" class="cs-text" v-html="data.text"></span>
                </div>
                <Slider class="slider" :data="data.list" v-slot="item">
                    <a v-if="item.slide.link" :href="item.slide.link">
                        <img
                            :src="item.slide.icon_image"
                            class="slider__item-image"
                        />
                        <h6 v-if="item.slide.title">
                            {{ item.slide.title }}
                        </h6>
                        <p v-if ="item.slide.text">
                            {{ item.slide.text }}
                        </p>
                    </a>
                    <div v-else>
                        <img
                            :src="item.slide.icon_image"
                            class="slider__item-image"
                        />
                        <h6 v-if="item.slide.title">
                            {{ item.slide.title }}
                        </h6>
                        <p v-if ="item.text">
                            {{ item.slide.text }}
                        </p> 
                    </div>
                </Slider>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'IconSlider',
    components: { 
        ColorSplit: () => import("../blocks_components/ColorSplit.vue"),
        Slider: () => import("../blocks_components/Slider.vue")
     },
    props: {
        data: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            slickOptions: {
                slidesToShow: 5,
                arrows: false,
                autoplay: true,
                autoplaySpeed: 5,
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 3
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            }
        }
    },
    methods: {
        next() {
            this.$refs.slick.next()
        },

        prev() {
            this.$refs.slick.prev()
        }
    },
    computed: {
        styleClass(){
            let result = ''

            if(this.data.style) result += ` cs-style-${this.data.style}`;

            return result
        }
    }
}
</script>

<style scoped lang="scss">
@import '../styles/main.scss';
.cs-logo-reel {
    position: relative;

    .header-content {
        text-align: center;
        margin-bottom: $header_margin;
    
        &-richtext {
            ::v-deep {
                * {
                    text-align: center;
                }
    
                p,
                span {
                    @include text;
                }
            }
        }
    }

    .slider {
        a {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            text-decoration: none;
            color: inherit;
        }
        .slider__item-image {
            height: 80px;
            width: 100%;
            object-fit: cover;
            margin-bottom: $theme_items_margin;
        }

        h6, p {
            text-align: center;
        }

        ::v-deep {
            .slider__arrow {
                font-size: 1.5rem !important
            }
        }
    }

    &.cs-style- {
        &color {
            @include cs-block-color;
            .cs-sub-title{
                color:$sub_title_color;
            }
            *, ::v-deep *{
                color:white;
            }
        }

        &light {
            @include cs-block-light;
            .cs-sub-title{
                color: $sub_title_color_light;
            }
        }

        &dark {
            @include cs-block-dark;
            .cs-sub-title{
                color: $sub_title_color_dark;
            }
        }
    }
}
</style>

